import React from "react"
import styled, { css } from "styled-components"
import { SignIn } from "../../../components/templates/auth/signin"
import { IFormField } from "../../../components/templates/auth/signin/form/form-meta"
import { ThrowError } from "../../../error/error"
import { media } from "../../../style/const/media-query"
import { NotificationActionDispatcher } from "../../../libs/notifications"
import {
  container,
  IAuthContainer,
} from "../../../components/templates/auth/components/container"
import { History } from "history"
import BackgroundImage from "../../../components/templates/auth/components/auth-frame/assets/background.jpg"

type IProps = {
  history: History
} & IAuthContainer

export class Component extends React.Component<IProps> {
  private onClickSignUpButton: () => void
  constructor(props: IProps) {
    super(props)
    this.onClickSignUpButton = () => {
      this.props.history.push("/signup")
    }
  }

  public render() {
    return (
      <AuthWrapper>
        <SignIn
          onClickSignUpButton={this.onClickSignUpButton}
          submit={this.submit}
        />
      </AuthWrapper>
    )
  }

  private submit = (values: IFormField) => {
    this.props.sessionActions.loginFromEmail(
      {
        email: values.email,
        password: values.password,
      },
      (success, e) => {
        if (success) {
          NotificationActionDispatcher.LogNotification("ログインしました")
          this.props.history.push("/")
        } else {
          ThrowError(e)
        }
      },
    )
  }
}

export const AuthWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-image: url(${BackgroundImage});
  background-size: cover;
  background-position: center;
  ${media.phone(css`
    min-height: auto;
    background-image: none;
  `)};
`

export default container(Component)
